import React, { useRef, useEffect } from 'react';
import './TabBar.css';

function TabBar({ tabs, activeTabId, onTabClick, onTabClose }) {
  const tabsRef = useRef(null);

  // Scroll active tab into view
  useEffect(() => {
    if (tabsRef.current && activeTabId) {
      const activeTabElement = tabsRef.current.querySelector(`[data-tab-id="${activeTabId}"]`);
      if (activeTabElement) {
        activeTabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
  }, [activeTabId]);

  if (!tabs || tabs.length === 0) {
    return (
      <div className="tab-bar tab-bar-empty">
        <div className="tab-empty-message">No tabs open</div>
      </div>
    );
  }

  return (
    <div className="tab-bar" ref={tabsRef}>
      {tabs.map(tab => (
        <div
          key={tab.id}
          data-tab-id={tab.id}
          className={`tab ${tab.id === activeTabId ? 'tab-active' : ''}`}
          onClick={() => onTabClick(tab.id)}
        >
          <span className="tab-icon">📄</span>
          <span className="tab-title">{tab.title}</span>
          <button
            className="tab-close"
            onClick={(e) => {
              e.stopPropagation();
              onTabClose(tab.id);
            }}
            aria-label="Close tab"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

export default TabBar;
